import React, { useEffect } from 'react';

import { PluginSlot } from '@openedx/frontend-plugin-framework';

import { reduxHooks } from 'hooks';
import LearnerDashboardNav from 'containers/LearnerDashboardNav';
import ProductCardGrid from 'containers/ProductCardGrid';
import StructuredCourseView from 'containers/StructuredCourseView';
import OthersView from 'containers/OthersView';
import NoCoursesView from './NoCoursesView';

import './index.scss';

const contentByKind = {
  productGrid: ProductCardGrid,
  structured: StructuredCourseView,
  flatList: OthersView,
};

/**
 * Renders the LearnerDashboardNav plus a router over selectedNavContent.kind:
 * productGrid -> ProductCardGrid, structured -> StructuredCourseView,
 * flatList -> OthersView, empty (or no nav items) -> NoCoursesView.
*/
export const CoursesPanel = () => {
  const navItems = reduxHooks.useNavItems();
  const selectedNavItem = reduxHooks.useSelectedNavItem();
  const selectNavItem = reduxHooks.useSelectNavItem();
  const { kind } = reduxHooks.useSelectedNavContent();

  const Content = contentByKind[kind];

  useEffect(() => {
    if (!selectedNavItem && navItems.length > 0) {
      const [first] = navItems;
      selectNavItem({ type: first.type, slug: first.slug });
    }
  }, [selectedNavItem, navItems, selectNavItem]);

  return (
    <div className="course-list-container">
      {navItems.length > 0 && (
        <PluginSlot id="learner_dashboard_nav">
          <LearnerDashboardNav />
        </PluginSlot>
      )}
      {navItems.length === 0 || !Content ? (
        <PluginSlot id="no_courses_view">
          <NoCoursesView />
        </PluginSlot>
      ) : (
        <PluginSlot id="course_list">
          <Content />
        </PluginSlot>
      )}
    </div>
  );
};

CoursesPanel.propTypes = {};

export default CoursesPanel;
